import React from "react";
import { VerifiedEmailScreenContainer } from "../../../containers";

export const VerifiedEmailScreen = () => {
  return <VerifiedEmailScreenContainer />;
};
